import React from 'react';
import { Box, Typography, Grid, Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import Header from '@/layouts/Header/Header';
import FooterBottom from '@/layouts/FooterBottom';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Cancel';

export default function SubscriptionPage() {

  const plans = [
    {
      name: 'HBN Free',
      price: '$0',
      description: 'Pay as you go with full flexibility',
      subText: 'Ideal for casual users or one-time lookups.',
      features: [
        { label: 'Profile', available: true },
        { label: 'Add Website', available: true },
        { label: 'Add Social media', available: true },
        { label: 'Chat', available: false },
        { label: 'Book Appointments', available: false },
        { label: 'Call Back', available: false },
        { label: 'Submit Documents', available: false },
        { label: 'Team account (Multiple users)', available: false },
        { label: 'Star Broker', available: false },
        { label: 'Top of Search results', available: false },
        { label: 'Review', available: false },
        { label: 'Google Review Sync', available: false },
        { label: 'Customer Support', available: true },
        { label: 'Advanced Analytics', available: false },
      ]
    },
    {
      name: 'HBN Pro',
      price: '$49.99 AUD',
      description: 'Pay as you go with full flexibility',
      subText: 'Ideal for deeper research and more expert options.',
      features: [
        { label: 'Profile', available: true },
        { label: 'Add Website', available: true },
        { label: 'Add Social media', available: true },
        { label: 'Chat', available: true },
        { label: 'Book Appointments', available: true },
        { label: 'Call Back', available: true },
        { label: 'Submit Documents', available: true },
        { label: 'Team account (Multiple users)', available: false },
        { label: 'Star Broker', available: false },
        { label: 'Top of Search results', available: false },
        { label: 'Review', available: true },
        { label: 'Google Review Sync', available: true },
        { label: 'Customer Support', available: true },
        { label: 'Advanced Analytics', available: true },
      ]
    },
    {
      name: 'HBN Premium',
      price: '$99.99 AUD',
      description: 'Pay as you go with full flexibility',
      subText: 'Full access for confident, informed decisions.',
      features: [
        { label: 'Profile', available: true },
        { label: 'Add Website', available: true },
        { label: 'Add Social media', available: true },
        { label: 'Chat', available: true },
        { label: 'Book Appointments', available: true },
        { label: 'Call Back', available: true },
        { label: 'Submit Documents', available: true },
        { label: 'Team account (Multiple users)', available: true },
        { label: 'Star Broker', available: true },
        { label: 'Top of Search results', available: true },
        { label: 'Review', available: true },
        { label: 'Google Review Sync', available: true },
        { label: 'Customer Support', available: true },
        { label: 'Advanced Analytics', available: true },
      ]
    }
  ];

  const handlePlanClick = (planName) => {
    console.log("Selected Plan:", planName);
  };

  return (
    <>
      <Header />
      <Box sx={{ minHeight: "80vh", backgroundColor: "#f9f9f9", pt: { xs: 8, md: 10 }, pb: 10, textAlign: "center", px: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: "#202020", fontSize: "1.6rem" }}>
          PRICING & PLANS
        </Typography>

        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, fontSize: "1.8rem" }}>
          <span style={{ color: "#5E5ACF" }}>Flexible Plans To Help You Find The </span>
          <span style={{ color: "#FBBC00" }}>Right Experts </span>
          <span style={{ color: "#5E5ACF" }}>On Your Terms</span>
        </Typography>

        <Typography variant="body1" sx={{ mb: 6, color: "#9199A8", fontSize: "0.9rem" }}>
          Pay only for what you need. Get full access to trusted service providers when you need them.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {plans.map((plan, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card 
                onClick={() => handlePlanClick(plan.name)}
                sx={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "translateY(-10px)", cursor: "pointer" },
                  backgroundColor: "#fff",
                  height: "100%"
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h6" sx={{ color: "#4B3F72", fontWeight: "bold", mb: 1, fontSize: "1.1rem" }}>
                    {plan.name}
                  </Typography>

                  <Box sx={{ display: 'inline-block', backgroundColor: '#F5B500', color: '#000', px: 2, py: 0.5, borderRadius: '6px', fontSize: '0.75rem', fontWeight: 500, mb: 2 }}>
                    {plan.description}
                  </Box>

                  <Typography variant="body2" sx={{ color: "#6c6c6c", mb: 2, fontSize: "0.85rem" }}>
                    {plan.subText}
                  </Typography>

                  <List dense sx={{ mb: 3 }}>
                    {plan.features.map((feature, idx) => (
                      <ListItem key={idx}>
                        <ListItemIcon>
                          {feature.available ? (
                            <CheckIcon sx={{ color: "green" }} />
                          ) : (
                            <CloseIcon sx={{ color: "red" }} />
                          )}
                        </ListItemIcon>
                        <ListItemText 
                          primary={feature.label} 
                          primaryTypographyProps={{ fontSize: "0.85rem" }}
                        />
                      </ListItem>
                    ))}
                  </List>

                  <Typography variant="h5" sx={{ color: "#4B3F72", mb: 1, fontSize: "1.4rem" }}>
                    {plan.price}
                  </Typography>

                  {/* Only for Pro and Premium */}
                  {plan.name !== 'HBN Free' && (
                    <Typography variant="body2" sx={{ color: "#9199A8", mb: 2, fontSize: "0.8rem" }}>
                      Per month billed yearly
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <FooterBottom />
    </>
  );
}
